import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { RestApiService } from '@/services'
import { ApplicationState } from '@/state/root.models'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { jsonToQueryString } from '@/utils'
import ActionTypes from '../constants'
import { GetUsersPayload, UserState, UsersResponse } from '../models'

import { USER } from './api.routes'

const apiService: RestApiService = Container.get(RestApiService)

export const getAllUsersThunk = createAsyncThunk(
  ActionTypes.GET_ALL_USERS,
  async (payload: GetUsersPayload, thunkAPI) => {
    try {
      apiService.requestParams = {
        method: 'GET',
        endpoint: USER.FIND_ALL,
        queries: jsonToQueryString(payload),
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: UsersResponse = await apiService.getAuthData(
        auth.token || '',
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      if (response.status && response.status !== 200) {
        const message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')

        thunkAPI.dispatch(
          setSnackbarAction({
            message,
            open: true,
            variant:
              response?.status && response?.status !== 200
                ? 'error'
                : 'success',
          }),
        )
      }

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const getAllUsersExtraReducer = (
  builder: ActionReducerMapBuilder<UserState>,
) => {
  builder.addCase(getAllUsersThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(getAllUsersThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false
    state.users = payload.docs
    state.pagination = {
      ...state.pagination,
      total: payload.total,
      pages: payload.pages,
      page: Number(payload.page),
      limit: Number(payload.limit),
    }
  })
}

export default getAllUsersExtraReducer
